import { dinero, toFormat } from 'dinero.js';
import * as Currencies from '@dinero.js/currencies';

function amountInMinimumUnits(amount: string | number, currency: string): number {
  const currencyObj = Currencies[currency as keyof typeof Currencies];
  return parseFloat(amount.toString()) * (currencyObj.base ** currencyObj.exponent);
}

function intlFormat(dineroObject: any, locale: string, options: Record<string, any> = {}) {
  function transformer({ amount, currency }: {amount: any; currency: any}) {
    return amount.toLocaleString(locale, {
      ...options,
      style: 'currency',
      currency: currency.code,
    });
  }

  return toFormat(dineroObject, transformer);
}

function displayInCurrency(amount: string | number, currency: string): string {
  return intlFormat(
    dinero({
      amount: amountInMinimumUnits(amount, currency),
      currency: Currencies[currency as keyof typeof Currencies],
    }),
    'en-US',
  );
}

export {
  displayInCurrency,
};
